export default __webpack_public_path__ + "static/media/patient_card.5f02b079.png";